import React from 'react';
import './styles.scss';
import doctorsImage from "../../assets/login_right_main_image.png";
import { useAuth } from '../../context/AuthContext';
import logo from "../../assets/platform_logo.png"
import topRightLogos from "../../assets/right_top_logos.png"

const LoginPage: React.FC = () => {
  const { login, getAccessToken } = useAuth();

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="welcome-text">
          <p>Boas-vindas ao</p>
          <div className='flex-space-between-row'>
            <img src={logo}></img>
            <h1 style={{ alignSelf: "center", marginLeft: "8px" }}>
              Soluções Integradas da Saúde
            </h1>
          </div>
          <button className="enter-button" onClick={login}>
            Acessar
          </button>
        </div>
      </div>
      <div className="login-right">
        <img src={doctorsImage} alt="Médicos analisando exame" />
        <img src={topRightLogos} style={{ position: "absolute", top: "30px", right: "30px", width: "200px", height: "auto" }}></img>
      </div>
    </div>
  );
};

export default LoginPage;
